import {mapGetters} from "vuex";
import remove from "../../mixins/remove";

export default {
    name: "strategy",
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            items: 'strategy/_getItems',
        }),
        headers() {
            return [
                {text: 'Title', value: "title"},
                {
                    text: 'Edit',
                    value: "actions",
                    align: "end",
                },
            ];
        },
    },
    methods: {
        removeItem() {
            this.$store.dispatch("strategy/deleteItem", this.selected);
            this.clearDialog();
        },
    },
    created() {
        this.$store.dispatch("strategy/getItems");
    },
    mixins: [remove],
};
